import { sprintf, __ } from '@wordpress/i18n';
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { decodeEntities } from '@wordpress/html-entities';
import { getSetting } from '@woocommerce/settings';
import $ from 'jquery'; // Ensure jQuery is imported if not already available globally

const settings = getSetting('dummy_data', {});

const defaultLabel = __('Dummy Payments', 'woo-gutenberg-products-block');
const label = decodeEntities(settings.title) || defaultLabel;

/**
 * Content component
 */
const Content = () => {
    return decodeEntities(settings.description || '');
};

/**
 * Label component
 *
 * @param {*} props Props from payment API.
 */
const Label = (props) => {
    const { PaymentMethodLabel } = props.components;
    return <PaymentMethodLabel text={label} />;
};

/**
 * Dummy payment method config object.
 */
const Dummy = {
    name: "dummy",
    label: <Label />,
    content: <Content />,
    edit: <Content />,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports,
    },
};

registerPaymentMethod(Dummy);

// Checkout listener
$(function() {
    $('form.checkout').on('checkout_place_order_success', function(event, data) {
        if (data.payment_result && data.payment_result.payment_details) {
            const locationUrlEntry = data.payment_result.payment_details.find(detail => detail.key === 'locationUrl');

            if (locationUrlEntry && locationUrlEntry.value) {
                window.open(locationUrlEntry.value, '_blank');
            }
        }
    });
});
